import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_trade2go.png",
      alt: "Estratégias trade2go",
    },
    title: "Tecnologia e inovação!",

    // String ou array de strings
    text: "Nossa tecnologia proprietária, atuante desde 2018, utiliza algoritmos inovadores em constante evolução que exploram padrões recorrentes no mercado de renda variável. Todas as nossas estratégias passam obrigatoriamente por métodos de validação confiáveis e são monitoradas diariamente. Além disso, criamos portfólios otimizados de estratégias, com bastante cuidado na gestão de risco, de modo que o dia a dia para o cliente seja o mais simples possível.",
    testimonial: {
      text: "Nossa missão é democratizar o acesso a investimentos automatizados inteligentes, unindo potencial de retorno com análise de risco controlado.",
      author: {
        name: "Bruno Ramos, CEO e estrategista-chefe da trade2go",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "Estratégias trade2go",
    heading: "Algoritmos inteligentes e exclusivos à sua disposição.",
    subtitle:
      "Estratégias e portfólios otimizados, desenvolvidos pelo estrategista-chefe certificado CNPI-T.",
  },

  cta: {
    title: "Conheça nossos planos.",
    subtitle: "Escolha o mais adequado para o seu perfil.",
    buttonText: "Escolha seu plano!",
  },

  about: {
    title: "Sobre a empresa",
    subtitle: "trade2go",
    col1: [
      "A trade2go é uma fintech fundada pelo seu atual CEO, Bruno Ramos, que é engenheiro eletrônico pela FEI, pós-graduado pela Poli-USP, programador, empreendedor e analista CNPI-T certificado pela APIMEC.",
      "Bruno construiu uma carreira de quase duas décadas entre empresas de tecnologia e do mercado automotivo, desenvolvendo e gerenciando produtos e modelos de negócios inovadores.",
      "Com esta bagagem, em 2018, decidiu aplicar os seus conhecimentos em programação, finanças, gestão, estratégias e inovação na área de investimentos automatizados. Estudou novas tecnologias e criou uma primeira linha de portfólios quantitativos para uso pessoal com resultados promissores.",
      "Em 2021, optou por uma transição de carreira e por ampliar os seus horizontes: fez uma volta ao mundo por 15 países, onde novas experiências, ideias e objetivos se tornaram claros.",
      "Decidiu, então, empreender com dedicação integral ao mundo dos investimentos, fundando a trade2go e ampliando os portfólios com estratégias ainda mais inovadoras.",
    ],
    col2: [
      "Em 2023, sempre buscando revolucionar o mercado de automação de estratégias, a trade2go fez uma parceria com a Daytrader Expert, fundada por Mauro Botto, engenheiro e trader profissional especialista em Price Action, para inovar, diversificar e possibilitar retornos substanciais combinados com uma abordagem estratégica e tecnológica única orientada a resultados.",
      "As estratégias de Price Action adotam análises de probabilidades e funções de inteligência para uma tomada de decisão observando a ação do preço em múltiplos contextos de forma única, considerando força, pressão, pernas, pontos de inflexão, impulso, correção, localização, ciclos de mercado, linhas de tendência, linhas de canal, suportes e resistências, além de incluir e calcular de forma inteligente o melhor retorno baseado em probabilidade e risco associado.",
      "Todas as estratégias da trade2go passam por revisões constantes de padrões bem como por análises estatísticas e de robustez avançadas.",
      "Venha investir com a tecnologia trade2go!",
    ],
  },

  stats: {
    title: "Alguns números da trade2go",
    subtitle: "Desempenho, segurança e tecnologia",
    data: [
      {
        value: "+1.5k",
        description: "Horas de validação",
      },
      {
        value: "+200",
        description: "Estratégias testadas",
      },
      {
        value: "+15k",
        description: "Linhas de código proprietário",
      },
      {
        value: "+5",
        description: "Anos desenvolvendo portfólios",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Por que utilizar os robôs da trade2go?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.ranking,
        title: "Certificação CNPI",
        description:
          "Nosso estrategista-chefe possui a certificação CNPI-T da APIMEC, o que o autoriza a emitir recomendações de investimento legalmente.",
      },
      {
        icon: iconsSet.growth,
        title: "Desempenho",
        description:
          "Estratégias validadas e otimizadas, ideais para trazer diversificação para a sua carteira de renda variável.",
      },
      {
        icon: iconsSet.lock,
        title: "Segurança",
        description:
          "As operações são feitas diretamente na sua conta da corretora, sendo que o resultado é apurado diariamente. Ninguém além de você terá acessos a saques ou retiradas.",
      },
      {
        icon: iconsSet.code,
        title: "Tecnologia",
        description:
          "Utilizamos tecnologias avançadas, inovação e validação estatística para disponibilizar sempre o melhor portfólio de estratégias.",
      },
      {
        icon: iconsSet.cloud,
        title: "Praticidade",
        description:
          "Não é preciso instalar nada nem ser expert: tudo é executado em nuvem, controlado pelo seu smartphone ou computador.",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte",
        description:
          "Nossa equipe está à disposição para tirar suas dúvidas sobre as estratégias e planos.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Tenho recomendado a trade2go a todos os amigos e familiares. Os resultados incríveis que obtive superaram minhas expectativas, sem falar no suporte excepcional da equipe que faz toda a diferença. Recomendo demais para quem busca sucesso no mercado financeiro.",
      author: "Alexandre Melara",
      job: "Consultor",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Graças às estratégias da trade2go, finalmente encontrei uma forma de potencializar meus investimentos com minicontratos eliminando o aspecto emocional.",
      author: "Ricardo Silva",
      job: "Administrador de Empresas",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos e vantagens!",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
